import React, { useContext } from 'react'
import { Link } from 'gatsby'
import slugify from 'slugify'
import FontContext from '../context/fontsize/fontContext'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import setupTags from '../utils/setupTags'

const useStyles = makeStyles((theme) => ({
	outerCtr: {
		paddingTop: '2em',
	},
	tags: {
		color: 'rgba(190, 190, 190, 1)',
		fontSize: '.7rem',
		marginBottom: 3,
		fontWeight: 400,
		textDecoration: 'none',
		textTransform: 'uppercase',
	},
	lightTags: {
		color: 'rgba(117,117,117, 1)',
		fontSize: '.7rem',
		marginBottom: 3,
		fontWeight: 400,
		textDecoration: 'none',
		textTransform: 'uppercase',
	},
	Hr: {
		color: 'rgba(117,117,117, 1)',
	},
	lightHr: {
		color: 'rgba(190, 190, 190, 1)',
	},
}))

const FeaturedCategories = ({ posts }) => {
	const classes = useStyles()
	const theme = useTheme()
	const newTags = setupTags(posts)
	const fontContext = useContext(FontContext)
	const { darkMode } = fontContext
	return (
		<Grid container direction='column' className={classes.outerCtr}>
			<Grid item lg={12}>
				<Typography
					variant='h6'
					style={{
						fontSize: '1rem',
						paddingBottom: '.25em',
						color: theme.palette.common.accent,
					}}
				>
					Related Categories
				</Typography>
			</Grid>
			<Grid
				item
				lg={12}
				style={{ paddingTop: '.25em', paddingBottom: '1.25em' }}
			>
				<Divider className={darkMode ? classes.Hr : classes.lightHr} />
			</Grid>
			{newTags.map((tag, index) => {
				const [text] = tag
				const slug = slugify(text, { lower: true })
				return (
					<Grid item xs={6} key={index} style={{ padding: '.5em 0' }}>
						<Link
							to={`/articles/categories/${slug}`}
							className={darkMode ? classes.tags : classes.lightTags}
						>
							<Typography variant='body2' style={{ fontSize: '.8125rem' }}>
								{text}
							</Typography>
						</Link>
					</Grid>
				)
			})}
		</Grid>
	)
}

export default FeaturedCategories
